

// eslint-disable-next-line
import { handleResponseJson,handleResponseVoid, handleError } from "../../apiUtils";
import { Chat } from "../Interfaces/Chat";
import { AIPhotoTaggingBusinessType } from "../Interfaces/AIPhotoTaggingBusinessType";
import { CloseOutType } from "../Interfaces/CloseOutType";
import { HeartBeatRequest } from "../Interfaces/HeartBeatRequest";
import { SessionPhotoTag } from "../Interfaces/SessionPhotoTag";
import { SessionPhoto } from "../Interfaces/SessionPhoto";
import { AIVideoFrameTag } from "../Interfaces/AIVideoFrameTag";
import { MentorSession } from "../Interfaces/MentorSession";
import { Registration } from "../Interfaces/Registration";
import { HeartBeatResult } from "../Interfaces/HeartBeatResult";
import { LiveSwitchTokenResult } from "../Interfaces/LiveSwitchTokenResult";
import { MentorToken } from "../Interfaces/MentorToken";

    /**
    * Abandons the session.
    **/
    export function abandonSession(sessionId: string, deviceId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/AbandonSession/${encodeURIComponent(sessionId)}/${encodeURIComponent(deviceId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Adds a chat.
    **/
    export function addChat(sessionId: string, chat: Chat, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/AddChat/${encodeURIComponent(sessionId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken, "Content-Type": "application/json" },
                    body: JSON.stringify(chat)
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Adds a photo to the session from an existing video frame tag.
    **/
    export function addVideoFrameTagToPhotos(sessionId: string, videoFrameTagId: string, authToken:string): Promise<SessionPhoto>{
        var url = `api/mentor/sessions/AddVideoFrameTagToPhotos/${encodeURIComponent(sessionId)}?videoFrameTagId=${encodeURIComponent(videoFrameTagId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Deletes a video.
    **/
    export function deleteVideos(sessionId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/DeleteVideos/${encodeURIComponent(sessionId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Excecute AI Tagging on video frame
    **/
    export function executeAIOnVideoFrame(file: Blob, dateTaken: Date, sessionId: string, lineOfBusiness: AIPhotoTaggingBusinessType, confidenceThreshold: number, reuseThreshold: number, authToken:string): Promise<AIVideoFrameTag>{
        var url = `api/mentor/sessions/ExecuteAIOnVideoFrame?dateTaken=${dateTaken}&sessionId=${encodeURIComponent(sessionId)}&lineOfBusiness=${lineOfBusiness}&confidenceThreshold=${confidenceThreshold}&reuseThreshold=${reuseThreshold}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: file
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Completes the client session.
    **/
    export function completeClientSession(sessionId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/CompleteClientSession/${encodeURIComponent(sessionId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Completes the mentor session.
    **/
    export function completeMentorSession(sessionId: string, closeOutType: CloseOutType, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/CompleteMentorSession/${encodeURIComponent(sessionId)}/${closeOutType}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Deletes a photo.
    **/
    export function deletePhoto(sessionId: string, photoId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/DeletePhoto/${encodeURIComponent(sessionId)}/${encodeURIComponent(photoId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Attempts to get AI for session Photo for provided Id
    **/
    export function runAIForPhotoId(sessionId: string, photoId: string, authToken:string): Promise<SessionPhotoTag>{
        var url = `api/mentor/sessions/RunAIForPhotoId/${encodeURIComponent(sessionId)}/${encodeURIComponent(photoId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Deletes a photo tag from a specified photo.
    **/
    export function deletePhotoTag(sessionId: string, photoId: string, photoTagId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/DeletePhotoTag/${encodeURIComponent(sessionId)}/${encodeURIComponent(photoId)}/${encodeURIComponent(photoTagId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Ends the mentor registration.
    **/
    export function endMentorRegistration(deviceId: string, sessionId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/EndMentorRegistration/${encodeURIComponent(deviceId)}/${encodeURIComponent(sessionId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Gets the session by identifier.
    **/
    export function getSessionById(sessionId: string, authToken:string): Promise<MentorSession>{
        var url = `api/mentor/sessions/GetSessionById/${encodeURIComponent(sessionId)}`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Returns currently active observers.
    **/
    export function getActiveObservers(sessionId: string, authToken:string): Promise<Registration[]>{
        var url = `api/mentor/sessions/GetActiveObservers?sessionId=${encodeURIComponent(sessionId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * A ping that lets the system know that the mentor is still active and to return any new info packets
    **/
    export function heartBeatPing(sessionId: string, heartbeatRequest: HeartBeatRequest, authToken:string): Promise<HeartBeatResult>{
        var url = `api/mentor/sessions/HeartBeatPing/${encodeURIComponent(sessionId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken, "Content-Type": "application/json" },
                    body: JSON.stringify(heartbeatRequest)
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Joins the session.
    **/
    export function joinSession(sessionId: string, deviceId: string, shareObserverName: boolean, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/JoinSession/${encodeURIComponent(sessionId)}?deviceId=${encodeURIComponent(deviceId)}&shareObserverName=${shareObserverName}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Gets the LiveSwitch token for the mentor.
    **/
    export function liveSwitchToken(sessionId: string, authToken:string): Promise<LiveSwitchTokenResult>{
        var url = `api/mentor/sessions/LiveSwitchToken/${encodeURIComponent(sessionId)}`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Refreshes the mentor token (using the admin API).
    **/
    export function refreshMentorToken( authToken:string): Promise<MentorToken>{
        var url = `api/mentor/sessions/RefreshMentorToken`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }

    /**
    * Creates a flattened version of the photo with tags on it as a separate asset.
    **/
    export function setFlattenedPhotoWithTags(sessionId: string, photoId: string, file: Blob, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/SetFlattenedPhotoWithTags/${encodeURIComponent(sessionId)}/${encodeURIComponent(photoId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: file
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Starts the session.
    **/
    export function startSession(sessionId: string, deviceId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/StartSession/${encodeURIComponent(sessionId)}?deviceId=${encodeURIComponent(deviceId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Updates the photo tags for a specific photo.
    **/
    export function updatePhotoTags(sessionId: string, photoId: string, tags: SessionPhotoTag[], authToken:string): Promise<void>{
        var url = `api/mentor/sessions/UpdatePhotoTags/${encodeURIComponent(sessionId)}/${encodeURIComponent(photoId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken, "Content-Type": "application/json" },
                    body: JSON.stringify(tags)
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Toggle Recording state
    **/
    export function toggleRecording(sessionId: string, isRecording: boolean, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/ToggleRecording?sessionId=${encodeURIComponent(sessionId)}&isRecording=${isRecording}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Removes user from session.
    **/
    export function removeUserFromSession(sessionId: string, deviceId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/RemoveUserFromSession/${encodeURIComponent(sessionId)}?deviceId=${encodeURIComponent(deviceId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Admits user to session from waiting room
    **/
    export function admitUserToSession(sessionId: string, deviceId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/AdmitUserToSession/${encodeURIComponent(sessionId)}?deviceId=${encodeURIComponent(deviceId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }

    /**
    * Denies user access to session from waiting room
    **/
    export function denyUserAccessToSession(sessionId: string, deviceId: string, authToken:string): Promise<void>{
        var url = `api/mentor/sessions/DenyUserAccessToSession/${encodeURIComponent(sessionId)}?deviceId=${encodeURIComponent(deviceId)}`;
        return (
                fetch(url, 
                {
                    method: "post",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseVoid)
                .catch(handleError)
               );
    }



